<!-- 更多渠道筛选弹框 by zhoujuan 2020/1/19 -->
<template>
  <van-dialog
  @confirm="confirm"
  :before-close="onBeforeClose"
  v-model="show"
  confirmButtonText="确定">
    <div v-html="indexParaphrase" class="content"></div>
  </van-dialog>
</template>

<script>
export default {
  props: ['show', 'indexParaphrase'],
  methods: {
    onBeforeClose (action, done) {
      if (action === 'confirm') {
        return done(false)
      }
    },
    // 确定
    confirm () {
      document.querySelector('.content').scrollTop = 0
      this.$emit('confirm')
    }
  }
}
</script>
<style lang="stylus" scoped>
.content{
  height calc(100vh / 3 - 50px)
  overflow auto
  padding 15px
  font-size 16px
  line-height 2em
  color #333
}
</style>



// WEBPACK FOOTER //
// src/pages/common/infoDialog.vue